// eslint-disable-next-line
import { UserLayout, BasicLayout, RouteView, BlankLayout, PageView } from '@/components/layouts'
import { bxAnaalyse } from '@/core/icons'

export const asyncRouterMap = [

  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    meta: { title: '首页' },
    redirect: '/dashboard/workplace',
    children: [
      // dashboard
      {
        path: '/dashboard',
        name: 'dashboard',
        redirect: '/dashboard/workplace',
        component: RouteView,
        hidden: true,
        meta: { title: '仪表盘', icon: bxAnaalyse, permission: [ 'dashboard' ] },
        children: [
          {
            path: '/dashboard/workplace',
            name: 'Workplace',
            component: () => import('@/views/dashboard/Workplace'),
            meta: { title: '工作台', permission: [ 'dashboard' ] }
          }
        ]
      },
      // Purchase
      {
        path: '/purchase',
        redirect: '/purchase/order',
        component: PageView,
        meta: { title: '购货', icon: 'shopping-cart', permission: [ 'form' ] },
        children: [
          {
            path: '/purchase/order',
            name: 'PurchaseOrder',
            component: () => import('@/views/purchase/Order'),
            meta: { title: '购货订单', hiddenHeaderContent: true, permission: [ 'form' ], group: true, groupBegin: true }
          },
          {
            path: '/purchase/order/list',
            name: 'PurchaseOrderList',
            hidden: true,
            component: () => import('@/views/purchase/OrderList'),
            meta: { title: '购货订单记录', hiddenHeaderContent: true, permission: [ 'form' ], group: true }
          },
          {
            path: '/purchase/order/edit/:id',
            name: 'PurchaseOrderEdit',
            hidden: true,
            component: () => import('@/views/purchase/OrderEdit'),
            meta: { title: '购货订单详情', hiddenHeaderContent: true, permission: [ 'form' ], group: true }
          },
          {
            path: '/purchase/invoice',
            name: 'PurchaseInvoice',
            component: () => import('@/views/purchase/Invoice'),
            meta: { title: '购货单', hiddenHeaderContent: true, permission: [ 'form' ], group: true }
          },
          {
            path: '/purchase/invoice/list',
            name: 'PurchaseInvoiceList',
            hidden: true,
            component: () => import('@/views/purchase/InvoiceList'),
            meta: { title: '购货单记录', hiddenHeaderContent: true, permission: [ 'form' ], group: true }
          },
          {
            path: '/purchase/invoice/edit/:id',
            name: 'PurchaseInvoiceEdit',
            hidden: true,
            component: () => import('@/views/purchase/InvoiceEdit'),
            meta: { title: '购货单详情', hiddenHeaderContent: true, permission: [ 'form' ], group: true }
          },
          {
            path: '/purchase/recede/edit/:id',
            name: 'PurchaseRecedeEdit',
            hidden: true,
            component: () => import('@/views/purchase/RecedeEdit'),
            meta: { title: '购货退货单详情', hiddenHeaderContent: true, permission: [ 'form' ], group: true }
          },
          {
            path: '/purchase/recede/list',
            name: 'PurchaseRecedeList',
            hidden: true,
            component: () => import('@/views/purchase/RecedeList'),
            meta: { title: '购货退货单记录', hiddenHeaderContent: true, permission: [ 'form' ], group: true }
          },
          {
            path: '/purchase/recede',
            name: 'PurchaseRecede',
            component: () => import('@/views/purchase/Recede'),
            meta: { title: '购货退货单', hiddenHeaderContent: true, permission: [ 'form' ], group: true, groupEnd: true, groupName: '采购单据' }
          },
          // {
          //   path: '/purchase/report/order',
          //   name: 'PurchaseReportOrder',
          //   component: () => import('@/views/purchase/report/Order'),
          //   meta: { title: '采购订单跟踪表', hiddenHeaderContent: true, permission: [ 'form' ], group: true, groupBegin: true }
          // },
          {
            path: '/purchase/report/entries',
            name: 'PurchaseReportEntries',
            component: () => import('@/views/purchase/report/Entries'),
            meta: { title: '采购明细表', hiddenHeaderContent: true, permission: [ 'form' ], group: true, groupBegin: true}
          },
          {
            path: '/purchase/report/summary/goods',
            name: 'PurchaseReportSummaryGoods',
            component: () => import('@/views/purchase/report/summary/Goods'),
            meta: { title: '采购汇总表（按商品）', hiddenHeaderContent: true, permission: [ 'form' ], group: true,groupEnd: true, groupName: '采购报表'}
          }
          // {
          //   path: '/purchase/report/summary/supplier',
          //   name: 'PurchaseReportSummarySupplier',
          //   component: () => import('@/views/purchase/report/summary/Supplier'),
          //   meta: { title: '采购汇总表（按供应商）', hiddenHeaderContent: true, permission: [ 'form' ], group: true, groupEnd: true, groupName: '采购报表' }
          // }
        ]
      },
      // sales
      {
        path: '/sales',
        redirect: '/sales/order',
        component: PageView,
        meta: { title: '销货', icon: 'code', permission: [ 'form' ] },
        children: [
          {
            path: '/sales/order',
            name: 'SalesOrder',
            component: () => import('@/views/sales/Order'),
            meta: { title: '销货订单', hiddenHeaderContent: true, permission: [ 'form' ], group: true, groupBegin: true }
          },
          {
            path: '/sales/order/list',
            name: 'SalesOrderList',
            hidden: true,
            component: () => import('@/views/sales/OrderList'),
            meta: { title: '销货订单记录', hiddenHeaderContent: true, permission: [ 'form' ], group: true }
          },
          {
            path: '/sales/order/edit/:id',
            name: 'SalesOrderEdit',
            hidden: true,
            component: () => import('@/views/sales/OrderEdit'),
            meta: { title: '销货货订单详情', hiddenHeaderContent: true, permission: [ 'form' ], group: true }
          },
          {
            path: '/sales/invoice',
            name: 'SalesInvoice',
            component: () => import('@/views/sales/Invoice'),
            meta: { title: '销货单', hiddenHeaderContent: true, permission: [ 'form' ], group: true }
          },
          {
            path: '/sales/invoice/list',
            name: 'SalesInvoiceList',
            hidden: true,
            component: () => import('@/views/sales/InvoiceList'),
            meta: { title: '销货单记录', hiddenHeaderContent: true, permission: [ 'form' ], group: true }
          },
          {
            path: '/sales/invoice/edit/:id',
            name: 'SalesInvoiceEdit',
            hidden: true,
            component: () => import('@/views/sales/InvoiceEdit'),
            meta: { title: '销货单详情', hiddenHeaderContent: true, permission: [ 'form' ], group: true }
          },
          {
            path: '/sales/recede/edit/:id',
            name: 'SalesRecedeEdit',
            hidden: true,
            component: () => import('@/views/sales/RecedeEdit'),
            meta: { title: '销货退货单详情', hiddenHeaderContent: true, permission: [ 'form' ], group: true }
          },
          {
            path: '/sales/recede/list',
            name: 'SalesRecedeList',
            hidden: true,
            component: () => import('@/views/sales/RecedeList'),
            meta: { title: '销货退货单记录', hiddenHeaderContent: true, permission: [ 'form' ], group: true }
          },
          {
            path: '/sales/recede',
            name: 'SalesRecede',
            component: () => import('@/views/sales/Recede'),
            meta: { title: '销货退货单', hiddenHeaderContent: true, permission: [ 'form' ], group: true, groupEnd: true, groupName: '销售单据'}
          },
          // {
          //   path: '/sales/report/order',
          //   name: 'SalesReportOrder',
          //   component: () => import('@/views/sales/report/Order'),
          //   meta: { title: '销售订单跟踪表', hiddenHeaderContent: true, permission: [ 'form' ], group: true, groupBegin: true }
          // },
          {
            path: '/sales/report/entries',
            name: 'SalesReportEntries',
            component: () => import('@/views/sales/report/Entries'),
            meta: { title: '销售明细表', hiddenHeaderContent: true, permission: [ 'form' ], group: true, groupBegin: true}
          },
          {
            path: '/sales/report/summary/goods',
            name: 'SalesReportSummaryGoods',
            component: () => import('@/views/sales/report/summary/Goods'),
            meta: { title: '销售汇总表（按商品）', hiddenHeaderContent: true, permission: [ 'form' ], group: true,  groupEnd: true, groupName: '销售报表' }
          }
          // {
          //   path: '/sales/report/summary/customer',
          //   name: 'SalesReportSummaryCustomer',
          //   component: () => import('@/views/sales/report/summary/Customer'),
          //   meta: { title: '销售汇总表（按客户）', hiddenHeaderContent: true, permission: [ 'form' ], group: true, groupEnd: true, groupName: '销售报表' }
          // }
        ]
      },
      // settings
      {
        path: '/settings',
        redirect: '/settings/customer/list',
        component: PageView,
        meta: { title: '资料', icon: 'form', permission: [ 'form' ] },
        children: [
          {
            path: '/settings/customer/list',
            name: 'SettingsCustomerList',
            component: () => import('@/views/settings/customer/List'),
            meta: { title: '客户管理', hiddenHeaderContent: true, permission: [ 'form' ], group: true, groupBegin: true }
          },
          {
            path: '/settings/supplier/list',
            name: 'SettingsSupplierList',
            component: () => import('@/views/settings/supplier/List'),
            meta: { title: '供应商管理', hiddenHeaderContent: true, permission: [ 'form' ], group: true }
          },
          {
            path: '/settings/goods/list',
            name: 'SettingsGoodsList',
            component: () => import('@/views/settings/goods/List'),
            meta: { title: '商品管理', hiddenHeaderContent: true, permission: [ 'form' ], group: true }
          },
          {
            path: '/settings/store/list',
            name: 'SettingsStoreList',
            component: () => import('@/views/settings/store/List'),
            meta: { title: '仓库管理', hiddenHeaderContent: true, permission: [ 'form' ], group: true, groupEnd: true, groupName: '基础数据' }
          },
          {
            path: '/settings/category/customer',
            name: 'SettingsCategoryCustomer',
            component: () => import('@/views/settings/category/Customer'),
            meta: { title: '客户类别', hiddenHeaderContent: true, permission: [ 'form' ], group: true, groupBegin: true }
          },
          {
            path: '/settings/category/supplier',
            name: 'SettingsCategorySupplier',
            component: () => import('@/views/settings/category/Supplier'),
            meta: { title: '供应商类别', hiddenHeaderContent: true, permission: [ 'form' ], group: true }
          },
          {
            path: '/settings/category/goods',
            name: 'SettingsCategoryGoods',
            component: () => import('@/views/settings/category/Goods'),
            meta: { title: '商品类别', hiddenHeaderContent: true, permission: [ 'form' ], group: true }
          },
          {
            path: '/settings/unit/list',
            name: 'SettingsUnitList',
            component: () => import('@/views/settings/unit/List'),
            meta: { title: '计量单位', hiddenHeaderContent: true, permission: [ 'form' ], group: true, groupEnd: true, groupName: '辅助资料' }
          }
        ]
      },
      // store
      {
        path: '/storage',
        redirect: '/storage/inventory',
        component: PageView,
        meta: { title: '仓库', icon: 'home', permission: [ 'form' ] },
        children: [
          {
            path: '/storage/inventory',
            name: 'StorageInventory',
            component: () => import('@/views/storage/Inventory'),
            meta: { title: '盘点', hiddenHeaderContent: true, permission: [ 'form' ], group: true, groupBegin: true }
          },
          {
            path: '/storage/inventory/list',
            name: 'StorageInventoryList',
            component: () => import('@/views/storage/inventory/List'),
            meta: { title: '盘点记录', hiddenHeaderContent: true, permission: [ 'form' ], group: true }
          },
          {
            path: '/storage/other/in',
            name: 'StorageOtherIn',
            component: () => import('@/views/storage/other/In'),
            meta: { title: '其他入库单', hiddenHeaderContent: true, permission: [ 'form' ], group: true }
          },
          {
            path: '/storage/other/in/list',
            name: 'StorageOtherInList',
            hidden: true,
            component: () => import('@/views/storage/other/InList'),
            meta: { title: '其他入库单记录', hiddenHeaderContent: true, permission: [ 'form' ], group: true }
          },
          {
            path: '/storage/other/in/edit/:id',
            name: 'StorageOtherInEdit',
            hidden: true,
            component: () => import('@/views/storage/other/InEdit'),
            meta: { title: '其他入库单详情', hiddenHeaderContent: true, permission: [ 'form' ], group: true }
          },
          {
            path: '/storage/other/out/list',
            name: 'StorageOtherOutList',
            hidden: true,
            component: () => import('@/views/storage/other/OutList'),
            meta: { title: '其他出库单记录', hiddenHeaderContent: true, permission: [ 'form' ], group: true, }
          },
          {
            path: '/storage/other/out',
            name: 'StorageOtherOut',
            component: () => import('@/views/storage/other/Out'),
            meta: { title: '其他出库单', hiddenHeaderContent: true, permission: [ 'form' ], group: true, groupEnd: true, groupName: '仓库单据' }
          },
          {
            path: '/storage/other/out/edit/:id',
            name: 'StorageOtherOutEdit',
            hidden: true,
            component: () => import('@/views/storage/other/OutEdit'),
            meta: { title: '其他出库单详情', hiddenHeaderContent: true, permission: [ 'form' ], group: true }
          },
          {
            path: '/storage/report/detail',
            name: 'StorageReportDetail',
            component: () => import('@/views/storage/report/Detail'),
            meta: { title: '商品收发明细表', hiddenHeaderContent: true, permission: [ 'form' ], group: true, groupBegin: true, groupEnd: true, groupName: '仓库报表'  }
          },
          // {
          //   path: '/storage/report/summary',
          //   name: 'StorageReportSummary',
          //   component: () => import('@/views/storage/report/Summary'),
          //   meta: { title: '商品收发汇总表', hiddenHeaderContent: true, permission: [ 'form' ], group: true, groupEnd: true, groupName: '仓库报表' }
          // }
        ]
      },
      // money
      {
        path: '/money',
        redirect: '/money/pay/list',
        component: PageView,
        meta: { title: '资金', icon: 'dollar', permission: [ 'form' ] },
        children: [
          {
            path: '/money/pay/list',
            name: 'MoneyPayList',
            component: () => import('@/views/money/pay/List'),
            meta: { title: '应付账款明细', hiddenHeaderContent: true, permission: [ 'form' ] }
          },
          {
            path: '/money/proceeds/list',
            name: 'MoneyProceedsList',
            component: () => import('@/views/money/proceeds/List'),
            meta: { title: '应收账款明细', hiddenHeaderContent: true, permission: [ 'form' ] }
          },
          {
            path: '/money/proceeds/add',
            name: 'MoneyProceedsAdd',
            hidden: true,
            component: () => import('@/views/money/proceeds/Add'),
            meta: { title: '新建应收账款单据', hiddenHeaderContent: true, permission: [ 'form' ] }
          }
        ]
      },
      // user
      {
        path: '/user',
        redirect: '/user/list',
        component: PageView,
        hidden: true,
        meta: { title: '账户', icon: 'user', permission: [ 'form' ] },
        children: [
          {
            path: '/user/profile/password',
            name: 'UserProfilePassword',
            component: () => import('@/views/user/profile/Password'),
            meta: { title: '密码修改', hiddenHeaderContent: true, permission: [ 'form' ] }
          }
        ]
      }
    ]
  },
  {
    path: '*', redirect: '/404', hidden: true
  }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
      },
      {
        path: 'register',
        name: 'register',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Register')
      },
      {
        path: 'register-result',
        name: 'registerResult',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/RegisterResult')
      }
    ]
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404')
  }

]
